import React from 'react';
import { PageHero } from '../components/layout/PageHero';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Reveal } from '../components/ui/Reveal';
import { CtaBand } from '../components/ui/CtaBand';
import { candidate } from '../data/site';
import { biography, gallery, timeline, values } from '../data/candidate';
const bioSections = [{
  heading: 'Early life',
  body: biography.earlyLife
}, {
  heading: 'Education',
  body: biography.education
}, {
  heading: 'Professional journey',
  body: biography.professional
}, {
  heading: 'Public service',
  body: biography.publicService
}, {
  heading: 'Leadership philosophy',
  body: biography.philosophy
}];
export function Candidate() {
  return <>
      <PageHero eyebrow="The candidate" title="Adebayo Sanni Bello" intro={biography.summary} crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Candidate'
    }]} image={candidate.portraitPrimary} imageAlt={`${candidate.name} at his desk`} data-id="element-663" data-mp="2os5mhqd6o86m" />

      <section className="bg-sand-50 py-16 lg:py-24" aria-labelledby="bio-heading" data-id="element-664" data-mp="sqr1r033oy60">
        <div className="mx-auto grid max-w-content gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-10" data-id="element-665" data-mp="nre55nmfgcq8">
          <div className="lg:col-span-4" data-id="element-666" data-mp="12fr4mukq4dph">
            <h2 id="bio-heading" className="font-display text-[30px] leading-tight text-ink lg:sticky lg:top-28" data-id="element-667" data-mp="12gtvx3lyki5x">
              A life in engineering, enterprise and public service.
            </h2>
          </div>
          <div className="lg:col-span-8" data-id="element-668" data-mp="16hvv5kfvku7w">
            <dl className="divide-y divide-sand-300 border-y border-sand-300" data-id="element-669" data-mp="16gukvi6oobr8">
              {bioSections.map(section => <div key={section.heading} className="grid gap-2 py-7 sm:grid-cols-4 sm:gap-6" data-id="element-670" data-mp="1gfaafgq2bcym">
                  <dt className="text-[12px] font-bold uppercase tracking-[0.12em] text-green-700" data-id="element-671" data-mp="3n5qa8xeaqaox">
                    {section.heading}
                  </dt>
                  <dd className="text-[16px] leading-relaxed text-slate-700 sm:col-span-3" data-id="element-672" data-mp="3i87zd1gpxlea">
                    {section.body}
                  </dd>
                </div>)}
            </dl>
          </div>
        </div>
      </section>

      <section className="bg-white py-16 lg:py-24" aria-labelledby="timeline-heading" data-id="element-673" data-mp="kqcohssl3flx">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-674" data-mp="pp62dmbs98mm">
          <SectionHeading eyebrow="The journey" title="A verified timeline" intro="Each entry is supported by public records available in the media centre." data-id="element-675" data-mp="pqh5rl1bged7" />
          <ol className="mt-12 border-l border-sand-300 pl-6 sm:pl-8" data-id="element-676" data-mp="yo168rrcu6mr">
            {timeline.map((entry, index) => <li key={entry.year} className="relative pb-10 last:pb-0" data-id="element-677" data-mp="18fnsrk957s4t" data-mpi={index}>
                <Reveal delay={Math.min(index, 6) * 0.03} data-id="element-678" data-mp="18evuu2s2pibd">
                  <span aria-hidden className="absolute -left-[31px] top-1.5 h-3 w-3 rounded-full border-2 border-white bg-green-600 sm:-left-[39px]" data-id="element-679" data-mp="1dfjnesvya77p" />
                  <p className="font-display text-[22px] leading-none text-gold-600" data-id="element-680" data-mp="32wx7btqe7hbk">
                    {entry.year}
                  </p>
                  <h3 className="mt-2 font-display text-[20px] leading-snug text-ink" data-id="element-681" data-mp="2xyvp1b0sjm15">
                    {entry.title}
                  </h3>
                  <p className="mt-1.5 max-w-2xl text-[15px] leading-relaxed text-slate-600" data-id="element-682" data-mp="2nzep7a8802d3">
                    {entry.description}
                  </p>
                </Reveal>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="bg-sand-100 py-16 lg:py-24" aria-labelledby="values-heading" data-id="element-683" data-mp="3gpmwu854r4df">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-684" data-mp="3buhcvevafzrz">
          <SectionHeading eyebrow="What he stands for" title="Four working principles" data-id="element-685" data-mp="36wplclyk2fob" />
          <ul className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-686" data-mp="88io8qqpu9l3">
            {values.map((value, index) => <li key={value.title} data-id="element-687" data-mp="3fphjxbosr6d" data-mpi={index}>
                <Reveal delay={index * 0.04} data-id="element-688" data-mp="3enz37scd2em">
                  <div className="h-full rounded-card border border-sand-200 bg-white p-6" data-id="element-689" data-mp="3k3vhge60gfor">
                    <h3 className="font-display text-[20px] text-ink" data-id="element-690" data-mp="3p3hx0u9ba80q">{value.title}</h3>
                    <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-691" data-mp="3a67ej0y941vi">
                      {value.description}
                    </p>
                  </div>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-white py-16 lg:py-24" aria-labelledby="gallery-heading" data-id="element-692" data-mp="6rl3ufmi5fih">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-693" data-mp="bqei4a9m5ajp">
          <SectionHeading eyebrow="On the road" title="Campaign gallery" data-id="element-694" data-mp="3t41slte8l3kr" />
          <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-695" data-mp="1y0h5jqd07yl">
            {gallery.map(item => <li key={item.src} className="overflow-hidden rounded-card" data-id="element-696" data-mp="pn1r5beubr5z">
                <img src={item.src} alt={item.alt} loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-697" data-mp="ufcr2e9kzcyj" />
              </li>)}
          </ul>
        </div>
      </section>

      <CtaBand title="Read the plan he intends to be judged on." description="Nine policy areas, each with published targets, funding logic and a first-100-days commitment." primary={{
      label: 'Explore the vision',
      to: '/vision'
    }} secondary={{
      label: 'View the agenda',
      to: '/agenda'
    }} data-id="element-698" data-mp="2a4avcog78ako" />
    </>;
}